//basic
import React from 'react'
import { toJS } from 'mobx'
import { observer, inject } from 'mobx-react'

//api
import { api } from '../../../functions/api'

//custom components
import CustomInput from '../../../components/basic/input'
import CustomButton from '../../../components/basic/CustomButton'
// import SelectSearch from '../../../components/basic/SelectSearch/SelectSearch'
import CustomAvatar from '../../../components/basic/customAvatar';

//material-ui
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    ListItem,
    CircularProgress,
    MuiThemeProvider,
    createMuiTheme,
} from '@material-ui/core'
// import { DateTimePicker } from 'material-ui-pickers'
// import { IconButton, InputAdornment } from '@material-ui/core'
// import CalendarToday from '@material-ui/icons/CalendarToday'
// import ExpandLess from '@material-ui/icons/ExpandLess';
// import ExpandMore from '@material-ui/icons/ExpandMore';

//style
import './AddEditItem.scss'

//other libraries

import image from '../../../assets/image/svg/logo.svg';

const materialTheme = createMuiTheme({
    typography: {
        useNextVariants: true
    },
    overrides: {
        MuiInput: {
            underline: {
                '&::after': {
                    borderBottomColor: '#777777',
                    borderBottom: '2px solid #777777 !important'
                }
            },
            disabled: {
                '&::before': {
                    borderBottom: '1px solid #777777 !important'
                }
            }
        },
        MuiDialogActions: {
            root: {
                overflow: 'initial'
            }
        },
        MuiDialogContent: {
            root: {
                overflow: 'initial',
                overflowY: 'initial'
            }
        },
        MuiDialog: {
            paper: {
                overflow: 'initial',
                overflowY: 'initial'
            }
        }
    }
})

@inject('translate')
@inject('internal')
@observer
export default class AddEditItem extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            listProducts: [],
            selectedProducts: [],
            image: null,
            production: false,
            shopDetail: {},
            openCollapseBussniessHours: false,
            openCollapseContact: false,
            openCollapseBasicInfo: false,
        }
    }

    componentDidMount() {
        // this.changeProductToCorretFormat()
        let isEditMode = toJS(this.props.internal.actionEdit)
        if (isEditMode.edit) {
            this.setState({ loading: true })
            this.loadShopDetail(isEditMode.id)
        }
        else {
            this.setState({ loading: false })
        }
    }

    changeProductToCorretFormat() {
        const { products } = toJS(this.props.internal.dataForTable.lists)
        let tmpProducts = []
        for (let i in products) {
            tmpProducts.push({
                label: products[i].name,
                value: products[i].id
            })
        }
        this.setState({ listProducts: tmpProducts })
    }

    loadShopDetail = async (id) => {
        let load_data = await api({
            url: `lists/shops/${id}`,
            method: 'get',
            authorization: this.props.internal.user.access_token,
            //TODO: vymazat
            // postman: true
        })

        if(load_data.success === true) {
            this.setState({
                loading: false,
                production: load_data.data.data.production,
                shopDetail: load_data.data.data
            })
        }
    }

    action = () => {
        // let name = this.name.state.value
        // let url = this.url.state.value
        
        let latitude = this.latitude.state.value
        let longitude = this.longitude.state.value

        // if(name !== "" && url !== "") {
            if (toJS(this.props.internal.actionEdit.edit)) {
                this.updateShopDetail()
            } else {
                this.createNewShop()
            }
        // }
        // else {
        //     this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.FILL_REQUIRED_INPUTS, true)
        // }
    }

    updateShopDetail = async () => {
        
        let id = toJS(this.props.internal.actionEdit.id)
        this.setState({loadingBtn: true})

        let update_data = await api({
            method: 'patch',
            url: `lists/shops/${id}`,
            authorization: this.props.internal.user.access_token,
            //TODO: vymazat
            // postman: true,
            params: {
                // name: this.name.state.value,
                // url: this.url.state.value,
                // // shop_id: 2,
                // description: this.description.state.value,
                // production: this.state.production,
                latitude: this.latitude.state.value,
                longitude: this.longitude.state.value
            }
        })

        if(update_data.success === true || (update_data.success === false && update_data.status === 201)) {
            this.props.internal.setSnackbar(update_data.data.message, true)
            this.setState({loadingBtn: false})
            this.props.onClose(true)
            // if(this.state.image !== null) {
            //     this.updateImage(id)
            // }
            // this.setProducts(id)
        }
        
    }

    createNewShop = async () => {
        this.setState({loadingBtn: true})

        let create_data = await api({
            method: 'post',
            url: 'products/gifts',
            authorization: this.props.internal.user.access_token,
            //TODO: vymazat
            // postman: true,
            params: {
                name: this.name.state.value,
                price_from: this.price_from.state.value,
                shop_id: 2,
                description: this.description.state.value,
                production: this.state.production
            }
        })

        if(create_data.success === true || (create_data.success === false && create_data.status === 201)) {
            if(this.state.image !== null) {
                this.updateImage(create_data.data.data.id)
            }
            // this.setProducts(create_data.data.data.id)
            
        }
    }

    updateImage = async(id) => {
        let update_image = await api({
            method: 'patch',
            url: `lists/shops/${id}`,
            authorization: this.props.internal.user.access_token,
            //TODO: vymazat
            // postman: true,

            formData: true,
            params: {
                photo: this.state.image
            }
        })
    }

    setProducts = async(id) => {
        let products = this.state.selectedProducts
        let ids = products.map(item => Number(item.value))
        let set_products = await api({
            method: 'patch',
            url: `lists/shops/${id}/pair-products`,
            //TODO: vymazat
            postman: true,
            params: {
                ids: ids
            }
        })

        if(set_products.success === true) {
            this.props.internal.setSnackbar(set_products.data.message, true)
            this.setState({loadingBtn: false})
            this.props.onClose(true)
        }
    }

    handleChangeCheckbox = event => {
        this.setState({ production: event.target.checked })
    }

    handleAddProduct = val => {
        this.setState({ selectedProducts: val })
    }

    handleChangePhoto = (data) => {
        this.setState({image: data})
        // this.props.internal.photoWasChanged(false)
        return Promise.resolve(false)
    }

    handleClickCollapse = () => {
        this.setState(state => ({ openCollapseBussniessHours: !state.openCollapseBussniessHours }));
    };

    handleClickCollapseContact = () => {
        this.setState(state => ({ openCollapseContact: !state.openCollapseContact }));
    };

    handleClickCollapseBasicInfo = () =>{
        this.setState(state => ({ openCollapseBasicInfo: !state.openCollapseBasicInfo }));
    }

    render() {
        return (
            <MuiThemeProvider theme={materialTheme}>
                <Dialog
                    open={this.props.open}
                    onClose={() => this.props.onClose(false)}
                    aria-labelledby='form-dialog-title'
                    classes={{
                        paper: 'addEditMenuItemDialog'
                    }}
                >
                    <DialogTitle id='form-dialog-title'>{this.props.title}</DialogTitle>
                    {this.state.loading ? (
                        <DialogContent>
                            <CircularProgress className={'circular-progress'} />
                        </DialogContent>
                    ) : (
                        <DialogContent className={'shopDetailDialog'}>
                            <div className={'giftImage'}>
                                <CustomAvatar
                                    //TODO: dorobit nacitanie a zobrazenie fotky z api
                                    src={image}
                                    actionUploadPhoto={this.handleChangePhoto}
                                />
                            </div>
                            <div className={'name-price'}>
                                        <CustomInput
                                            ref={ref => (this.name = ref)}
                                            text={this.props.translate.i18n.MODULES.SHOPS.NAME}
                                            value={this.state.shopDetail.name || ''}
                                            id={'name'}
                                            required
                                        />
                                        <CustomInput
                                            ref={ref => (this.url = ref)}
                                            text={this.props.translate.i18n.MODULES.SHOPS.URL}
                                            value={this.state.shopDetail.url || ''}
                                            id={'url'}
                                            className={'w-50'}
                                            required
                                        />
                                    </div>
                                    <CustomInput
                                        ref={ref => (this.description = ref)}
                                        text={this.props.translate.i18n.MODULES.SHOPS.DESCRIPTION_FOOTER}
                                        // value={this.props.idCategory ? this.editCategory.name : ""}
                                        value={this.state.shopDetail.description || ''}
                                        id={'description'}
                                        className={'w-100'}
                                        multiline={true}
                                    />
                                    <ListItem
                                        dense
                                        onChange={this.handleChangeCheckbox}
                                        className={'list-item'}
                                    >
                                        <input
                                            id={'production'}
                                            type='checkbox'
                                            value={'production'}
                                            defaultChecked={this.state.production}
                                        />
                                        <label htmlFor={'production'}>
                                            {this.props.translate.i18n.GLOBAL.TABLE.ACTIVE}
                                        </label>
                                    </ListItem>
                            {/* <ListItem button onClick={this.handleClickCollapseBasicInfo} disableGutters>
                                <ListItemText  primary={this.props.translate.i18n.MODULES.SHOPS.BASIC_INFO} className={'primary-text title'}/>
                                {this.state.openCollapseBasicInfo ? <ExpandLess /> : <ExpandMore />}
                            </ListItem>
                            <Collapse in={this.state.openCollapseBasicInfo} timeout="auto" unmountOnExit>
                                <List component="div" disablePadding>
                                    <div className={'name-price'}>
                                        <CustomInput
                                            ref={ref => (this.name = ref)}
                                            text={this.props.translate.i18n.MODULES.SHOPS.NAME}
                                            value={this.state.shopDetail.name || ''}
                                            id={'name'}
                                            required
                                        />
                                        <CustomInput
                                            ref={ref => (this.url = ref)}
                                            text={this.props.translate.i18n.MODULES.SHOPS.URL}
                                            value={this.state.shopDetail.url || ''}
                                            id={'url'}
                                            className={'w-50'}
                                            required
                                        />
                                    </div>
                                    <CustomInput
                                        ref={ref => (this.description = ref)}
                                        text={this.props.translate.i18n.MODULES.SHOPS.DESCRIPTION_FOOTER}
                                        // value={this.props.idCategory ? this.editCategory.name : ""}
                                        value={this.state.shopDetail.description || ''}
                                        id={'description'}
                                        className={'w-100'}
                                        multiline={true}
                                    />
                                    <ListItem
                                        dense
                                        onChange={this.handleChangeCheckbox}
                                        className={'list-item'}
                                    >
                                        <input
                                            id={'production'}
                                            type='checkbox'
                                            value={'production'}
                                            defaultChecked={this.state.production}
                                        />
                                        <label htmlFor={'production'}>
                                            {this.props.translate.i18n.GLOBAL.TABLE.ACTIVE}
                                        </label>
                                    </ListItem>
                                </List>
                            </Collapse>
                            <ListItem button onClick={this.handleClickCollapse} disableGutters>
                                <ListItemText  primary={this.props.translate.i18n.MODULES.SHOPS.BUSSNIESS_HOURS} className={'primary-text title'}/>
                                {this.state.openCollapseBussniessHours ? <ExpandLess /> : <ExpandMore />}
                            </ListItem>
                            <Collapse in={this.state.openCollapseBussniessHours} timeout="auto" unmountOnExit>
                                <List component="div" disablePadding>
                                    <div className={'name-price'}>
                                        <CustomInput
                                            ref={ref => (this.week = ref)}
                                            text={this.props.translate.i18n.MODULES.SHOPS.BUSSNIESS_HOURS_WEEK}
                                            value={this.state.shopDetail.opening_hours_mon_fri || ''}
                                            id={'week'}
                                            required
                                        />
                                        <CustomInput
                                            ref={ref => (this.weekend = ref)}
                                            text={this.props.translate.i18n.MODULES.SHOPS.BUSSNIESS_HOURS_WEEKEND}
                                            value={this.state.shopDetail.opening_hours_sat_sun || ''}
                                            id={'weekend'}
                                            className={'w-50'}
                                            required
                                        />
                                    </div>
                                </List>
                            </Collapse>
                            
                            <ListItem button onClick={this.handleClickCollapseContact} disableGutters>
                                <ListItemText  primary={this.props.translate.i18n.MODULES.SHOPS.CONTACT}className={'primary-text title'}/>
                                {this.state.openCollapseContact ? <ExpandLess /> : <ExpandMore />}
                            </ListItem>
                            <Collapse in={this.state.openCollapseContact} timeout="auto" unmountOnExit>
                                <List component="div" disablePadding>
                                    <div className={'name-price'}>
                                        <CustomInput
                                            ref={ref => (this.contact_email = ref)}
                                            text={this.props.translate.i18n.GLOBAL.CONTACT.EMAIL}
                                            value={this.state.shopDetail.contact_email || ''}
                                            id={'contact_email'}
                                            required
                                        />
                                        <CustomInput
                                            ref={ref => (this.contact_phone = ref)}
                                            text={this.props.translate.i18n.GLOBAL.CONTACT.PHONE}
                                            value={this.state.shopDetail.contact_phone || ''}
                                            id={'contact_phone'}
                                            className={'w-50'}
                                            required
                                        />
                                    </div>
                                    <div className={'name-price'}>
                                        <CustomInput
                                            ref={ref => (this.street_name = ref)}
                                            text={this.props.translate.i18n.GLOBAL.ADRESS.ADRESS}
                                            value={this.state.shopDetail.street_name || ''}
                                            id={'street_name'}
                                            required
                                        />
                                        <CustomInput
                                            ref={ref => (this.street_no = ref)}
                                            text={this.props.translate.i18n.GLOBAL.ADRESS.STREET_NO}
                                            value={this.state.shopDetail.street_no || ''}
                                            id={'street_no'}
                                            className={'w-50'}
                                            required
                                        />
                                    </div>
                                    <div className={'name-price'}>
                                        <CustomInput
                                            ref={ref => (this.zip = ref)}
                                            text={this.props.translate.i18n.GLOBAL.ADRESS.ZIP}
                                            value={this.state.shopDetail.zip || ''}
                                            id={'zip'}
                                            required
                                        />
                                        <CustomInput
                                            ref={ref => (this.city = ref)}
                                            text={this.props.translate.i18n.GLOBAL.ADRESS.CITY}
                                            value={this.state.shopDetail.city || ''}
                                            id={'city'}
                                            className={'w-50'}
                                            required
                                        />
                                    </div>
                                    <div className={'name-price'}>
                                        <CustomInput
                                            ref={ref => (this.latitude = ref)}
                                            text={this.props.translate.i18n.GLOBAL.CONTACT.LATITUDE}
                                            value={this.state.shopDetail.latitude || ''}
                                            id={'latitude'}
                                        />
                                        <CustomInput
                                            ref={ref => (this.longitude = ref)}
                                            text={this.props.translate.i18n.GLOBAL.CONTACT.LONGITUDE}
                                            value={this.state.shopDetail.longitude || ''}
                                            id={'longitude'}
                                            className={'w-50'}
                                        />
                                    </div>
                                </List>
                            </Collapse> */}
                            
                            
                        </DialogContent>
                    )}
                    <DialogActions>
                        <Button onClick={() => this.props.onClose(false)} className={'gray-text'}>
                            {this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                        </Button>
                        <CustomButton
                            progressBar={this.state.loadingBtn}
                            onClick={this.action}
                            mystyle={'btn-white-bg'}
                            title={this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                            justText
                            disabled={this.state.loading}
                        />
                    </DialogActions>
                </Dialog>
            </MuiThemeProvider>
        )
    }
}



// WEBPACK FOOTER //
// ./src/screens/shops/AddEditItem/AddEditItem.jsx